import { useEffect, useState } from 'react';
import { Col, Input, Row, Table } from 'antd';

export const AddressTable = ({columns, records, row_key, selectRow}) => {

    const [ filteredRecords, setFilteredRecords ] = useState([])
    const [ search, setSearch ] = useState("")
    
    useEffect(() => {

        setFilteredRecords(records)

        return () => { setFilteredRecords([]); setSearch("") }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [records])


    useEffect( () => {
 
        let fr = structuredClone([...records]);

        if (search.length > 0) {

            setFilteredRecords(fr.filter((item) => JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ))

        } else {

            setFilteredRecords(fr)
        }

    }, [search])
    
    const onRowClick = (record) => {
        return {
            onClick: () => {
                selectRow(record)
            },
        };
    };

    
    const searchBox = () => {

        return (
            <div style={{marginBottom: 30}}>
                <Row gutter={10}>
                    <Col sm={24}>
                        <Input value={search} onChange={(e) => setSearch(e.target.value)} style={{width: '100%'}} placeholder={`Search by anything...`}/>
                    </Col>
                </Row>
                
            </div>
        )
    }

    const resultsTable = (data) => {

        return (
            filteredRecords && <Table bordered size='large' pagination={false} rowKey={row_key} columns={columns} dataSource={data} onRow={onRowClick} />
        )
    }
    
    return (
        records &&
        <div style={{padding: 20}}>
            {searchBox()}{ resultsTable(filteredRecords) }
        </div>
    )
    
}

export default AddressTable;